import React from "react";
import CognitiveLogo from "./CognitiveLogo";

// Footer component with branding
const Footer = () => (
  <footer className="py-16 bg-gray-50">
    <div className="max-w-7xl mx-auto px-4">
      <div className="flex items-center justify-center gap-3 mb-4">
        <CognitiveLogo size={24} />
        <span className="text-lg font-semibold text-gray-900">
          Bear Strategy Lab
        </span>
      </div>
      <p className="text-gray-600 text-center">
        © 2025 Bear Strategy Lab. All rights reserved.
      </p>
    </div>
  </footer>
);

export default Footer;
